var _style, _g, _path, _path2, _path3, _path4, _path5, _g2, _polygon, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarbetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "38px",
    viewBox: "0 0 130 38",
    style: {
      enableBackground: "new 0 0 130 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:#6A438F;}\n\t.st2{fill:#E2B5D4;}\n\t.st3{fill:#B985BB;}\n\t.st4{fill:#8658A0;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:url(#SVGID_00000023988344037421496680000011180359854563623098_);}\n\t.st8{fill:url(#SVGID_00000070102047454220040990000014193161694362120383_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,32.8L4,28.2h0.6c1.5,0.8,4.1,1.2,5.9,1.2c1.5,0,4.3-0.2,4.5-2.1c0.2-1.2-1.5-1.9-2.3-2.3l-3.2-1.7 c-2.7-1.4-3.8-3.9-3.5-6c0.6-4.1,3.6-5.6,7.5-5.6c2.6,0,4.5,0.2,6.6,1.1l-0.6,4.6h-0.6c-1.3-0.8-3.4-1.2-5-1.2 c-0.9,0-2.8,0.1-3,1.3c-0.1,0.6,1.1,1.4,1.9,1.8l3.5,1.8c3.1,1.6,4,4,3.7,6.4c-0.7,5-4.6,6.5-9.2,6.5C8.3,33.9,5.3,33.5,3.3,32.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,12.2h5.4l-0.6,4.5h-5.4l-1.5,10.5c-0.2,1.8,0.3,2.2,2.3,2.2c1,0,2-0.3,3.1-0.9h0.6L32.7,33 c-1.6,0.6-3,0.9-4.3,0.9c-5.7,0-6.8-2.5-6.1-7.6l1.3-9.7h-2.4l0.6-4.5h2.4L25,7.4h5.2L29.5,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,16.6h-0.6c-1.7-0.8-4.6,0-6.4,1.1l-2.2,15.8h-5.2l3-21.3h5l-0.2,1.3h0.2c2.3-1.1,3.9-1.7,7-1.7 L72.9,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.3,33.9c-2.8,0-5.1-2.3-5.1-5.2v-25h5.2v9h0.2c1.3-0.7,2.5-0.9,3.9-0.9c6.5,0,9.7,4.6,9.7,10.8 c0,6.3-3,11.4-10.4,11.4L77.3,33.9L77.3,33.9z M77.3,28.1c0,0.6,0.6,1.2,1.2,1.2h1.7c4.6,0,5.5-2.6,5.5-6.8c0-3.5-1.2-6.2-4.8-6.2 c-1.3,0-2.4,0.2-3.6,0.5C77.3,16.8,77.3,28.1,77.3,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.6,24.8c0.4,3.3,3.5,4.7,6.6,4.7c1.8,0,3.9-0.3,5.7-1.3h0.6v4.7c-2.3,0.8-4.3,1-6.7,1 c-6.9,0-11.7-3.8-11.7-11c0-5.2,3.1-11.2,10-11.2c7.5,0,9.9,6.3,9.5,13.1C112.6,24.8,98.6,24.8,98.6,24.8z M98.7,20.6h8.7 c-0.2-2.7-1.6-4.4-4.2-4.4C100.5,16.2,98.9,18.1,98.7,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.6,12.2h5.4v4.5h-5.4v10.5c0,1.8,1,2.2,2.6,2.2c1,0,2-0.3,3-0.9h0.6V33c-1.5,0.6-2.9,0.9-4.1,0.9 c-5,0-7.1-2.5-7.1-7.6v-9.7H113v-4.5h2.4V7.4h5.2V12.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.4,31.7c0,0.2,0,0.4,0,0.6c-0.2,1-1.1,1.9-2.2,2c-1.1,0.1-2.2-0.6-3.1-1.3c-2.5-1.8-4.9-3.5-7.4-5.3 c-1.5-1-3-2.1-3.9-3.7c-1.8-3.3-0.2-7.5,3.1-9.1c1.9-0.9,4.2-0.9,6,0.1c1.2,0.7,2.2,1.9,2.9,3.1s1.2,2.6,1.6,4 c0.9,2.6,1.8,5.2,2.6,7.8C57.2,30.5,57.4,31.1,57.4,31.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.2,34.1c-0.2,0.1-0.4,0.1-0.6,0.1c-1.1,0.1-2.2-0.5-2.5-1.5c-0.4-1.1,0-2.3,0.4-3.4c1-2.8,2-5.7,3-8.5 c0.6-1.7,1.2-3.5,2.5-4.7c2.6-2.7,7.2-2.3,9.6,0.4c1.4,1.5,2,3.8,1.5,5.8c-0.4,1.4-1.2,2.6-2.2,3.6s-2.2,1.8-3.4,2.6 c-2.3,1.6-4.5,3.1-6.8,4.7C40.3,33.6,39.8,33.9,39.2,34.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.7,18.4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5-1-0.2-2.2,0.6-2.9c0.9-0.8,2.1-0.8,3.3-0.8c3,0,6,0,9.1,0 c1.8,0,3.7,0,5.3,0.8c3.4,1.6,4.5,6,2.8,9.2c-1,1.8-2.9,3.2-5,3.4c-1.4,0.1-2.9-0.3-4.1-0.9s-2.5-1.5-3.6-2.3 c-2.2-1.6-4.4-3.2-6.7-4.8C32.6,19.2,32.1,18.9,31.7,18.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,6c0.1-0.2,0.2-0.3,0.4-0.5c0.8-0.7,2-0.9,3-0.3s1.4,1.8,1.8,2.9c0.9,2.9,1.9,5.7,2.8,8.6 c0.6,1.7,1.1,3.5,0.9,5.3c-0.5,3.7-4.3,6.2-7.9,5.5c-2-0.4-3.9-1.8-4.7-3.7c-0.6-1.3-0.6-2.8-0.5-4.2c0.2-1.4,0.6-2.8,1.1-4.1 c0.8-2.6,1.7-5.2,2.5-7.8C44,7,44.2,6.4,44.5,6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.0507,
    y1: 14.8894,
    x2: 54.5648,
    y2: 21.1449,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37437"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.8,15.4c0.2,0.1,0.4,0.2,0.6,0.3c0.9,0.6,1.3,1.8,1,2.8C62,19.6,61,20.3,60,20.9c-2.6,1.6-5.2,3.1-7.7,4.7 c-1.5,0.9-3.1,1.9-4.9,2.1c-3.7,0.4-7-2.8-7.2-6.4c-0.1-2.1,0.8-4.2,2.5-5.4c1.1-0.9,2.6-1.3,4-1.4c1.4-0.1,2.9,0,4.3,0.1 c2.7,0.2,5.5,0.4,8.2,0.7C59.7,15.2,60.3,15.2,60.8,15.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.7,18.9h-2.8l0.1,1.3l0.1,2.1c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0,0.5c0,0.2,0.1,0.4,0.2,0.6l0,0 c0,0,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.2,0.2,0.5,0.4,0.9,0.6c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2h0.1h0.1 c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.3-0.1,0.5-0.2c0.4-0.2,0.7-0.4,0.9-0.6c0,0,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2l0,0 c0.1-0.2,0.2-0.4,0.2-0.6s0-0.4,0-0.5s0-0.2,0-0.3l0.1-2.1l0.1-1.3H46.7z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "48.7,17.6 48.5,18 48.1,18 47.9,17.6 47.1,17.6 46.9,18 46.4,18 46.3,17.6 45.4,17.6 45.3,18  44.8,18 44.7,17.6 43.7,17.6 43.8,18.8 49.5,18.8 49.6,17.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183207473106081887550000014056400521485916863_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.4051,
    y1: 19.43,
    x2: 43.5753,
    y2: 17.2268,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26737"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183207473106081887550000014056400521485916863_)"
    },
    d: "M46.7,19.6l-0.2-0.5h-2.4l0.1,1.1 c0.3-0.4,0.7-0.4,0.8-0.4s0.1,0,0.1,0c-0.3,0-0.8,0.5-0.9,1l0.1,1.5c0.2-0.2,0.4-0.2,0.5-0.2c0.2,0,0.3,0.1,0.3,0.1l0,0 c-0.3,0-0.7,0.3-0.7,0.8v0.1v0.1l0,0l0,0c0,0.2,0.1,0.4,0.2,0.6c0.2-0.5,0.6-0.5,0.6-0.5c-0.2,0.1-0.4,0.5-0.3,0.9 c0.2,0.2,0.5,0.4,0.9,0.6c0-0.5,0.3-0.6,0.3-0.6s-0.2,0.4,0.2,0.8c0.2,0.1,0.4,0.1,0.6,0.2c0.2-0.1,0.4-0.1,0.6-0.2 c0.4-0.4,0.2-0.8,0.2-0.8s0.3,0.1,0.3,0.6c0.4-0.2,0.6-0.4,0.9-0.6c0.1-0.4-0.1-0.8-0.3-0.9c0,0,0.4,0,0.6,0.5 c0.1-0.2,0.1-0.4,0.2-0.6l0,0l0,0v-0.1V23c0-0.4-0.4-0.8-0.7-0.8l0,0c0,0,0.1-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0.2l0.1-1.5 c-0.1-0.5-0.6-1-0.9-1c0,0,0,0,0.1,0c0.2,0,0.5,0,0.8,0.4l0.1-1.1h-2.4L46.7,19.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082334238459581713520000011290226936598613655_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7485,
    y1: 22.5896,
    x2: 45.3985,
    y2: 20.9739,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEC932"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26737"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082334238459581713520000011290226936598613655_)"
    },
    points: "48.8,17.8 48.6,18.2  47.9,18.2 47.8,17.8 47.2,17.8 47,18.2 46.3,18.2 46.1,17.8 45.6,17.8 45.4,18.2 44.7,18.2 44.5,17.8 43.9,17.8 44,18.6  49.3,18.6 49.4,17.8  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.7,20.8c0-0.3,0.2-0.5,0.5-0.5h0.5c0.5,0,0.9,0.3,0.9,0.7c0,0.2-0.1,0.5-0.3,0.5l0,0 c0.3,0.1,0.5,0.3,0.5,0.6c0,0.6-0.5,0.8-1,0.8h-1v-2.1H45.7z M46.2,21.4h0.4c0.2,0,0.5,0,0.5-0.3c0-0.2-0.2-0.3-0.5-0.3h-0.3 c-0.1,0-0.1,0.1-0.1,0.1S46.2,21.4,46.2,21.4z M46.7,21.8h-0.4v0.7h0.5c0.3,0,0.5,0,0.5-0.4C47.2,21.8,46.9,21.8,46.7,21.8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarbetLogo);
export default __webpack_public_path__ + "static/media/starbet-logo.ad25c134ff6ffdfd37d7ba49e62f40c8.svg";
export { ForwardRef as ReactComponent };